import DOMPurify from "dompurify";

export function stripTags(html: string): string {
  return DOMPurify.sanitize(html, { RETURN_DOM: true }).textContent.trim();
}
